<!--
  Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

@if (!isUserActive()) {
  <p-dialog id="user-session-dialog" [style]="{width: '350px', height: '175px'}"
    [closable]="false" [modal]="true"
    [closeOnEscape]="false" [blockScroll]="true">
    <p-header>
      Session Timeout
    </p-header>
    <div id="user-session-content" class="grid grid-cols-12 content-center">
      <div class="col-span-4">
        <i class="fa fa-3x fa-exclamation-triangle" aria-hidden="true" style="color: red;"></i>
      </div>
      <div class="col-span-8 col-start-2">
        <span>{{message()}}</span>
        <br>
          @if (countdownActive()) {
            <span>You will be logged out in <strong>{{counter()}}</strong> seconds</span>
          }
        </div>
      </div>
      <footer>
        @if (countdownActive()) {
          <button type="button" pButton gmPrimary class="p-button-sm"
          (click)="extendUserSession()" label="Stay signed in"></button>
        }
        @if (!countdownActive()) {
          <button type="button" pButton gmPrimary class="p-button-sm"
          (click)="onReloadApplication()" label="Reload"></button>
        }
      </footer>
    </p-dialog>
  }
